define('presentation/settings/closeAccount/viewModels/closeAccountViewModel',[
    'businessServices/authentication/accountPlanInfo',
    'businessServices/authentication/authenticationManager',
    'businessServices/authentication/sessionAccountInfo',
    'businessServices/login/logoutRouteEvaluator',
    'common/collections/collectionSorter',
    'common/collections/enumerationKeyValueConverter',
    'common/promises/promiseFactory',
    'constants/accountStatusEnumerations',
    'constants/billingMethodConstants',
    'constants/closeAccountConstants',
    'entities/accountClosedFeedbackEntity',
    'plugins/router',
    'presentation/common/modal',
    'presentation/settings/closeAccount/facades/closeAccountFacade',
    'presentation/settings/closeAccount/presentationObjects/closeAccountFeaturePresentationObject',
    'presentation/settings/closeAccount/presentationObjects/closeAccountNoLongerNeededFeedbackReasonPresentationObject',
    'presentation/settings/closeAccount/presentationObjects/closeAccountTooExpensiveFeedbackReasonPresentationObject',
    'presentation/settings/closeAccount/presentationObjects/closeAccountLiveReceptionistIssuePresentationObject',
    'presentation/settings/closeAccount/validators/closeAccountValidator',
    'presentation/settings/closeAccount/viewModels/closeAccountActionModalViewModel',
    'settings/navigationConfiguration'
], function () {
    return function () {
        const self = this;

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');
        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
        const CloseAccountActionModalViewModelConstructor = require('presentation/settings/closeAccount/viewModels/closeAccountActionModalViewModel');
        const CloseAccountFeaturePresentationObjectConstructor = require('presentation/settings/closeAccount/presentationObjects/closeAccountFeaturePresentationObject');
        const CloseAccountNoLongerNeededFeedbackReasonPresentationObjectConstructor = require('presentation/settings/closeAccount/presentationObjects/closeAccountNoLongerNeededFeedbackReasonPresentationObject');
        const CloseAccountTooExpensiveFeedbackReasonPresentationObjectConstructor = require('presentation/settings/closeAccount/presentationObjects/closeAccountTooExpensiveFeedbackReasonPresentationObject');
        const CloseAccountLiveReceptionistIssuePresentationObjectConstructor = require('presentation/settings/closeAccount/presentationObjects/closeAccountLiveReceptionistIssuePresentationObject');
        const CollectionSorterConstructor = require('common/collections/collectionSorter');
        const AccountClosedFeedbackEntity = require('entities/accountClosedFeedbackEntity');

        const _accountPlanInfo = require('businessServices/authentication/accountPlanInfo');
        const _authenticationManager = require('businessServices/authentication/authenticationManager');
        const _accountStatusEnumerations = require('constants/accountStatusEnumerations');
        const _billingMethodConstants = require('constants/billingMethodConstants');
        const _logoutRouteEvaluator = require('businessServices/login/logoutRouteEvaluator');
        const _i18n = require('i18next');
        const _promiseFactory = new PromiseFactoryConstructor();
        const _router = require('plugins/router');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _actionModal = new ActionModalViewModelConstructor();
        const _sessionAccountInfo = require('businessServices/authentication/sessionAccountInfo');
        const _closeAccountConstants = require('constants/closeAccountConstants');
        const _closeAccountReasons = _closeAccountConstants.reasons;
        const _collectionSorter = new CollectionSorterConstructor();
        const _noLongerNeededReasons = _closeAccountConstants.noLongerNeededReasons;
        const _tooExpensiveReasons = _closeAccountConstants.tooExpensiveReasons;
        const _lacksFeaturesOptions = _closeAccountConstants.lacksFeaturesOptions;
        const _keyValueConverter = require('common/collections/enumerationKeyValueConverter');

        let _validator = null;
        let _facade = null;
        let _modalService = null;

        const DROPDOWN_OPTION_YES = {
            id: "1",
            description: "Yes"
        };
        const DROPDOWN_OPTION_NO = {
            id: "0",
            description: "No"
        };
        const YES_NO_DROPDOWN_OPTIONS = [DROPDOWN_OPTION_NO, DROPDOWN_OPTION_YES];

        const OTHER_OPTION = 'Other';

        self.modelStateObserver = null;
        self.isAccountInFreeTrial = false;

        self.hasLiveReceptionistPackage = ko.observable(false);

        self.isImpersonating = ko.pureComputed(() => _sessionAccountInfo.isImpersonating());

        self.closeAccountFeedbackReasons = ko.observableArray([]);
        self.tooExpensiveFeedbackReasons = ko.observableArray([]);
        self.noLongerNeededFeedbackReasons = ko.observableArray([]);
        self.liveReceptionistIssueList = ko.observableArray([]);
        self.featuresList = ko.observableArray([]);
        self.ratingOptions = ko.observableArray([]);
        self.yesNoDropdownOptions = ko.observableArray(YES_NO_DROPDOWN_OPTIONS);
        self.showPortOutInstructions = ko.observable(true);
        self.fraudStatuses = _keyValueConverter.convertToKeyValues(_accountStatusEnumerations.fraudStatus);

        self.selectedCloseAccountFeedbackReason = ko.observable().extend({observeState: true});
        self.selectedFraudStatus = ko.observable().extend({observeState: true});

        self.lacksFeaturesOtherFeedback = ko.observable().extend({observeState: true});
        self.otherFeatureSelected = ko.observable();

        self.billingIssueFeedback = ko.observable().extend({observeState: true});
        self.technicalIssueFeedback = ko.observable().extend({observeState: true});
        self.tooDifficultToUseFeedback = ko.observable().extend({observeState: true});
        self.poorCustomerServiceFeedback = ko.observable().extend({observeState: true});

        self.tooExpensiveReason = ko.observable().extend({observeState: true});
        self.tooExpensiveOtherFeedback = ko.observable().extend({observeState: true});

        self.noLongerNeededReason = ko.observable().extend({observeState: true});
        self.noLongerNeededOtherFeedback = ko.observable().extend({observeState: true});

        self.liveReceptionistIssueOtherFeedback = ko.observable().extend({observeState: true});
        self.otherLiveReceptionistIssueSelected = ko.observable();

        self.worthThePriceFeedback = ko.observable().extend({observeState: true});
        self.otherFeedback = ko.observable().extend({observeState: true});

        self.areYouSwitchingServices = ko.observable().extend({observeState: true});
        self.whichService = ko.observable().extend({observeState: true});
        self.howLikelyAreYouToRecommend = ko.observable().extend({observeState: true});
        self.isRatingBypassSelected = ko.observable(false);
        self.additionalFeedback = ko.observable().extend({observeState: true});

        self.cancellationComment = ko.observable();

        self.closeAccountButtonText = ko.pureComputed(() => _i18n.t('closeAccount:closeAccount'));
        self.pleaseSelectPlaceHolderMessage = _i18n.t('closeAccount:pleaseSelect');

        self.showLacksFeaturesForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.lacksFeatures;
        });
        self.showLacksFeaturesOtherFeedback = ko.pureComputed(() => self.otherFeatureSelected());
        self.isLacksFeaturesValid = ko.pureComputed(() => {
            if (self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.lacksFeatures) {
                return !self.featuresList.isInvalid();
            }
            return true;
        });

        self.showTooDifficultToUseForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.tooDifficult;
        });
        self.showBillingIssueForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.billingProblem;
        });
        self.showFraudStatusForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.fraud;
        });
        self.showTechnicalIssueForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.technicalProblem;
        });
        self.showPoorCustomerServiceForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.poorCustomerService;
        });
        self.showTooExpensiveFeedbackForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.tooExpensive;
        });
        self.showTooExpensiveOtherFeedback = ko.pureComputed(() => self.tooExpensiveReason() === _tooExpensiveReasons.other);

        self.showNoLongerNeededFeedbackForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.noLongerNeeded;
        });
        self.showNoLongerNeededOtherFeedback = ko.pureComputed(() => self.noLongerNeededReason() === _noLongerNeededReasons.other);

        self.showLiveReceptionistIssueFeedbackForm = ko.pureComputed(() => {
            return self.hasLiveReceptionistPackage() && self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.liveReceptionistIssue;
        });
        self.showLiveReceptionistIssueOtherFeedback = ko.pureComputed(() => self.otherLiveReceptionistIssueSelected());
        self.isLiveReceptionistIssueValid = ko.pureComputed(() => {
            if (self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.liveReceptionistIssue) {
                return !self.liveReceptionistIssueList.isInvalid();
            }
            return true;
        });

        self.showWorthThePriceFeedbackForm = ko.pureComputed(() => {
            return self.hasLiveReceptionistPackage();
        });

        self.showOtherFeedbackForm = ko.pureComputed(() => {
            return self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.other;
        });

        self.showSwitchingServicesForm = ko.pureComputed(() => {
            if (!self.selectedCloseAccountFeedbackReason() ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.fraud ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.termsOfUseViolation ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.nonPayment ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.writtenRequest ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.portOut) {
                return false;
            }
            return true;
        });
        self.showWhichService = ko.pureComputed(() => {
            return self.areYouSwitchingServices() === DROPDOWN_OPTION_YES.id;
        });

        self.showRatingAndAdditionalFeedbackForm = ko.pureComputed(() => {
            if (self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.fraud ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.termsOfUseViolation ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.nonPayment ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.writtenRequest ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.portOut) {
                return false;
            }
            return true;
        });

        self.showCancellationComment = ko.pureComputed(() => {
            if (self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.fraud ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.termsOfUseViolation ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.nonPayment ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.writtenRequest ||
                self.selectedCloseAccountFeedbackReason() === _closeAccountReasons.portOut) {
                return true;
            }
            return false;
        });

        self.customerDidNotProvideRating = ko.pureComputed(() => {
            return "closeAccount:customerDidNotProvideRating";
        });

        self.onRatingOptionClicked = (selectedOption) => {
            self.howLikelyAreYouToRecommend(selectedOption.id);
            self.isRatingBypassSelected(false);
            self.ratingOptions().forEach((option) => {
                if (option.id === selectedOption.id) {
                    option.isSelected(true);
                } else {
                    option.isSelected(false);
                }
            });
        };

        const _buildRatingOptions = () => {
            const ratingOptions = [];
            for (let i = 1; i <= 10; i++) {
                ratingOptions.push({
                    id: i,
                    isSelected: ko.observable(false)
                });
            }
            self.ratingOptions(ratingOptions);
        };

        const _sortWithOtherLast = (collection, sortProperty, isOtherOption) => {
            _collectionSorter.sort(collection, sortProperty, true);

            const otherIndex = collection.findIndex(isOtherOption);
            if (otherIndex > -1) {
                collection.push(collection.splice(otherIndex, 1)[0]);
            }
            return collection;
        };

        const _buildCloseAccountFeedbackReasons = (closeAccountFeedbackReasons) => {
            return _sortWithOtherLast(
                closeAccountFeedbackReasons,
                "description",
                (reason) => reason.id.toString() === _closeAccountReasons.other
            );
        };

        const _buildTooExpensiveFeedbackReasons = (tooExpensiveFeedbackReasons) => {
            const sortedTooExpensiveReasons = _sortWithOtherLast(
                tooExpensiveFeedbackReasons,
                "description",
                (reason) => reason.id.toString() === _tooExpensiveReasons.other.toString()
            );
            return sortedTooExpensiveReasons.map((reason) => {
                const closeAccountTooExpensiveFeedbackReasonPresentationObject = new CloseAccountTooExpensiveFeedbackReasonPresentationObjectConstructor();
                closeAccountTooExpensiveFeedbackReasonPresentationObject.text = reason.description;
                closeAccountTooExpensiveFeedbackReasonPresentationObject.value = reason.id;
                return closeAccountTooExpensiveFeedbackReasonPresentationObject;
            });
        };

        const _buildNoLongerNeededFeedbackReasons = (noLongerNeededFeedbackReasons) => {
            const sortedNoLongerNeededReasons = _sortWithOtherLast(
                noLongerNeededFeedbackReasons,
                "description",
                (reason) => reason.id.toString() === _noLongerNeededReasons.other.toString()
            );
            return sortedNoLongerNeededReasons.map((reason) => {
                const closeAccountNoLongerNeededFeedbackReasonPresentationObject = new CloseAccountNoLongerNeededFeedbackReasonPresentationObjectConstructor();
                closeAccountNoLongerNeededFeedbackReasonPresentationObject.text = reason.description;
                closeAccountNoLongerNeededFeedbackReasonPresentationObject.value = reason.id;
                return closeAccountNoLongerNeededFeedbackReasonPresentationObject;
            });
        };

        const _buildLiveReceptionistIssueList = (liveReceptionistIssueList) => {
            const sortedIssues = _sortWithOtherLast(
                liveReceptionistIssueList,
                "displayName",
                (issue) => issue.displayName === OTHER_OPTION
            );
            return sortedIssues.map((issue) => {
                const closeAccountLiveReceptionistIssuePresentationObject = new CloseAccountLiveReceptionistIssuePresentationObjectConstructor();
                closeAccountLiveReceptionistIssuePresentationObject.id = issue.id;
                closeAccountLiveReceptionistIssuePresentationObject.description = issue.displayName;
                if (issue.displayName === OTHER_OPTION) {
                    closeAccountLiveReceptionistIssuePresentationObject.isSelected = self.otherLiveReceptionistIssueSelected;
                }
                return closeAccountLiveReceptionistIssuePresentationObject;
            });
        };

        const _buildFeaturesList = (featuresList) => {
            const sortedFeatures = _sortWithOtherLast(
                featuresList,
                "displayName",
                (feature) => feature.displayName === OTHER_OPTION
            );
            return sortedFeatures.map((feature) => {
                const closeAccountFeaturePresentationObject = new CloseAccountFeaturePresentationObjectConstructor();
                closeAccountFeaturePresentationObject.id = feature.id;
                closeAccountFeaturePresentationObject.description = feature.displayName;
                if (feature.displayName === OTHER_OPTION) {
                    closeAccountFeaturePresentationObject.isSelected = self.otherFeatureSelected;
                }
                return closeAccountFeaturePresentationObject;
            });
        };

        const _populateCloseAccountReasons = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getCloseAccountReasons()
                    .fail(promise.reject)
                    .done((closeAccountFeedbackReasons, tooExpensiveFeedbackReasons, noLongerNeededFeedbackReasons, liveReceptionistIssueList, featuresList) => {
                        self.closeAccountFeedbackReasons(_buildCloseAccountFeedbackReasons(closeAccountFeedbackReasons));
                        self.tooExpensiveFeedbackReasons(_buildTooExpensiveFeedbackReasons(tooExpensiveFeedbackReasons));
                        self.noLongerNeededFeedbackReasons(_buildNoLongerNeededFeedbackReasons(noLongerNeededFeedbackReasons));
                        self.liveReceptionistIssueList(_buildLiveReceptionistIssueList(liveReceptionistIssueList));
                        self.featuresList(_buildFeaturesList(featuresList));

                        promise.resolve();
                    });
            });
        };

        const _getAccountPlan = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getAccountPlan()
                    .fail(promise.reject)
                    .done((accountPlan) => {
                        self.hasLiveReceptionistPackage(accountPlan.liveReceptionistPackage !== null);
                        promise.resolve();
                    });
            });
        };

        const _getBillingMethod = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getBillingMethod()
                    .fail(promise.reject)
                    .done((billingMethod) => {
                        self.billingMethod = billingMethod || _billingMethodConstants.CreditCard;
                        promise.resolve();
                    });
            });
        };

        const _getIsAccountInFreeTrial = () => {
            return _promiseFactory.defer((promise) => {
                _facade.isAccountInFreeTrial()
                    .fail(promise.reject)
                    .done((isAccountInFreeTrial) => {
                        self.isAccountInFreeTrial = isAccountInFreeTrial;
                        promise.resolve();
                    });
            });
        };

        const _showCloseAccountActionModal = () => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _actionModal.clearModal();
                _actionModal.setContentViewModel(CloseAccountActionModalViewModelConstructor);
                _actionModal.setHeaderText({i18n: 'closeAccount:areYouSure'});
                _actionModal.setSubmitButtonText({i18n: 'closeAccount'});
                _actionModal.setOnSubmitCallback(self.submitAction);
                _actionModal.shouldDisplayCancelButton(true);
                _actionModal.shouldDisplayAgentBypassButton(false);
                _actionModal.shouldDisplaySubmitButton(true);
                _actionModal.shouldDisplayDefaultFooterMessage(false);

                _actionModal.showModal()
                    .done((result) => {
                        if (result === "cancel") {
                            _modalService.closeModal(_actionModal);
                        }
                        promise.resolve(result);
                    });
            });
        };

        self.accountClosedFeedback = () => {
            const accountClosedFeedback = new AccountClosedFeedbackEntity();
            accountClosedFeedback.accountClosedFeedbackTypeDiscriminator = self.selectedCloseAccountFeedbackReason();
            accountClosedFeedback.howLikelyToRecommend = self.howLikelyAreYouToRecommend();
            accountClosedFeedback.generalFeedback = self.additionalFeedback();
            accountClosedFeedback.worthThePriceFeedback = self.worthThePriceFeedback();
            if (self.areYouSwitchingServices() !== null && self.areYouSwitchingServices() !== undefined) {
                accountClosedFeedback.isSwitchingService = self.areYouSwitchingServices() === DROPDOWN_OPTION_YES.id;
            }
            accountClosedFeedback.switchingServiceName = self.whichService();
            accountClosedFeedback.lacksFeaturesFeedbackReasons = self.featuresList().filter((feature) => {
                return feature.isSelected();
            }).map((feature) => {
                return {
                    lacksFeaturesReasonId: feature.id,
                    lacksFeaturesOtherFeedback: feature.description === OTHER_OPTION ? self.lacksFeaturesOtherFeedback() : null
                };
            });
            accountClosedFeedback.liveReceptionistIssueFeedbackReasons = self.liveReceptionistIssueList().filter((issue) => {
                return issue.isSelected();
            }).map((issue) => {
                return {
                    liveReceptionistIssueReasonId: issue.id,
                    liveReceptionistIssueOtherFeedback: issue.description === OTHER_OPTION ? self.liveReceptionistIssueOtherFeedback() : null
                };
            });
            accountClosedFeedback.difficultToUseFeedback = self.tooDifficultToUseFeedback();
            accountClosedFeedback.accountClosedTooExpensiveFeedbackTypeDiscriminator = self.tooExpensiveReason();
            accountClosedFeedback.tooExpensiveOtherFeedback = self.tooExpensiveOtherFeedback();
            accountClosedFeedback.fraudStatus = self.selectedFraudStatus();
            accountClosedFeedback.billingProblemFeedback = self.billingIssueFeedback();
            accountClosedFeedback.technicalProblemFeedback = self.technicalIssueFeedback();
            accountClosedFeedback.poorCustomerServiceFeedback = self.poorCustomerServiceFeedback();
            accountClosedFeedback.accountClosedNoLongerNeededFeedbackTypeDiscriminator = self.noLongerNeededReason();
            accountClosedFeedback.noLongerNeededOtherFeedback = self.noLongerNeededOtherFeedback();
            accountClosedFeedback.otherFeedback = self.otherFeedback();

            const accountClosedFeedbackReason = self.closeAccountFeedbackReasons().find((reason) => {
                return reason.id.toString() === self.selectedCloseAccountFeedbackReason();
            });
            accountClosedFeedback.reasonForCancellation = accountClosedFeedbackReason ? accountClosedFeedbackReason.description : null;
            return accountClosedFeedback;
        };

        self.submitAction = () => {
            _promiseFactory.timeoutMilliSeconds = 60000;
            return _promiseFactory.deferWithMinimumWait((promise) => {
                self.modelStateObserver.saveData();
                _logoutRouteEvaluator.setLogoutRoute(_getAccountClosedRoute());
                const accountClosedFeedback = self.accountClosedFeedback();
                _facade.closeAccount(accountClosedFeedback, self.cancellationComment())
                    .fail(promise.reject)
                    .done(() => {
                        promise.resolve(false);
                        _authenticationManager.logout()
                            .done(() => {
                                promise.resolve(true);
                            });
                    });
            });
        };

        const _getAccountClosedRoute = () => {
            if (self.isAccountInFreeTrial === true) {
                return _navigationConfiguration.accountClosedFreeTrial;
            }
            switch (self.billingMethod) {
                case _billingMethodConstants.Ach:
                    return _navigationConfiguration.accountClosedAch;
                case _billingMethodConstants.Invoice:
                    return _navigationConfiguration.accountClosedInvoice;
                default:
                    return _navigationConfiguration.accountClosed;
            }
        };

        self.validate = () => _validator.validate();

        self.closeAccount = () => {
            return _promiseFactory.deferWithMinimumWait((promise) => {
                _validator.validate()
                    .fail(promise.reject)
                    .done((isValid) => {
                        if (isValid === false) {
                            promise.resolve(false);
                            return;
                        }
                        _showCloseAccountActionModal();
                        promise.resolve(true);
                    });
            });
        };

        self.onClosePortInstructionsWarningBox = () => {
            self.showPortOutInstructions(false);
        };

        self.cancelForm = () => {
            self.modelStateObserver.navigateWithoutWarning = true;
            _router.navigate(_navigationConfiguration.billingProfile);
        };

        self.activate = () => {
            const ModalServiceConstructor = require('presentation/common/modal');
            _modalService = new ModalServiceConstructor();

            const ValidatorConstructor = require('presentation/settings/closeAccount/validators/closeAccountValidator');
            _validator = new ValidatorConstructor();

            const CloseAccountFacadeConstructor = require('presentation/settings/closeAccount/facades/closeAccountFacade');
            _facade = new CloseAccountFacadeConstructor();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {
            _buildRatingOptions();
            _populateCloseAccountReasons();
            _getAccountPlan();
            _getIsAccountInFreeTrial();
            _getBillingMethod();

            self.modelStateObserver = new ModelStateObserverConstructor(self, true);
            self.modelStateObserver.commitData();

            _validator.registerViewModel(self, _facade);

            return _promiseFactory.wait();
        };
    };
});
